module.exports = __webpack_public_path__ + "static/media/Roadmap.6295c1cb.png";